/* CompuMac × Apple HIG — Bewegung und Material (2026-09-27, Claude). Ergänzt cm-motion.js, ersetzt nichts.
   · Kopfzeile: stärkeres Glas, sobald Inhalt darunter scrollt.
   · Handy: Glas-Leiste versteckt sich beim Runterscrollen, kommt beim Hochscrollen zurück (wie iOS 26).
   · Segment-Steuerungen: ein weißer Schieber gleitet mit Federkurve zum gewählten Reiter.
   · Lichtkante folgt dem Zeiger auf Glas- und Kartenflächen (nur Geräte mit Maus/Trackpad).
   Alles respektiert „Bewegung reduzieren“; ohne JavaScript bleibt die Seite vollständig bedienbar. */
(() => {
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');

  /* Kopfzeile und Tab-Leiste */
  let lastY = scrollY;
  let ticking = false;
  const onScroll = () => {
    ticking = false;
    const y = scrollY;
    root.classList.toggle('hig-scrolled', y > 8);
    const delta = y - lastY;
    if (Math.abs(delta) > 6) {
      root.classList.toggle('hig-tabbar-hidden', delta > 0 && y > 160 && !reduced.matches);
      lastY = y;
    }
    if (y < 40) root.classList.remove('hig-tabbar-hidden');
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  /* Liquid Glass passt sich an: sobald das dunkle Startbild unter der Kopfzeile weg ist, wird das Glas hell */
  const hero = document.querySelector('.cm-experience-hero');
  if (hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => root.classList.toggle('hig-over-light', !entry.isIntersecting), { rootMargin: '-90px 0px 0px 0px' }).observe(hero);
  }

  /* Segment-Steuerungen mit gleitendem Schieber */
  const segmented = (track) => {
    if (track.dataset.higSeg) return;
    const items = () => [...track.querySelectorAll(':scope > button, :scope > a')];
    const activeItem = () => items().find((el) => el.getAttribute('aria-selected') === 'true' || el.classList.contains('is-active'));
    if (!items().length) return;
    track.dataset.higSeg = '1';
    const thumb = document.createElement('span');
    thumb.className = 'hig-seg-thumb';
    thumb.setAttribute('aria-hidden', 'true');
    track.prepend(thumb);
    const place = (animate) => {
      const el = activeItem();
      const list = items();
      // Nur einzeilige Leisten bekommen den Schieber; umbrechende Raster (Handy) behalten ihren Hintergrund.
      const oneRow = list.every((x) => x.offsetTop === list[0].offsetTop);
      track.classList.toggle('hig-seg-ready', Boolean(el) && oneRow);
      if (!el || !oneRow) { thumb.style.opacity = '0'; return; }
      if (!animate || reduced.matches) thumb.style.transition = 'none';
      thumb.style.opacity = '1';
      thumb.style.width = `${el.offsetWidth}px`;
      thumb.style.height = `${el.offsetHeight}px`;
      thumb.style.transform = `translate(${el.offsetLeft}px, ${el.offsetTop}px)`;
      if (!animate || reduced.matches) requestAnimationFrame(() => { thumb.style.transition = ''; });
    };
    new MutationObserver(() => place(true)).observe(track, { subtree: true, attributes: true, attributeFilter: ['aria-selected', 'class'] });
    addEventListener('resize', () => place(false), { passive: true });
    track.addEventListener('scroll', () => place(false), { passive: true });
    place(false);
    if (document.fonts?.ready) document.fonts.ready.then(() => place(false));
  };

  /* Mega-Menü der Kopfzeile (01.10.2026): mit Maus öffnet es beim Zeigen und schließt erst kurz nach dem Verlassen,
     damit ein kurzer Ausrutscher auf dem Weg ins Menü es nicht zuklappt. Auf Touch bleibt es beim Tippen (summary).
     06.10.2026 (Inhaber: „when clicked it should stay, but it disappears sometimes“): ein angeklicktes Menü ist
     festgehalten — es schließt nicht mehr beim Verlassen mit der Maus, nur per Klick daneben, Escape, erneutem Klick
     auf den Eintrag oder einem anderen angeklickten Menü; solange eines festgehalten ist, öffnet Zeigen kein anderes.
     Öffnen/Schließen anderer Menüs, Klick daneben und Escape regelt weiter cm-motion.js — hier nur Hover-Absicht,
     Tastatur-Fokus und der ruhige Wechsel von einem Menü ins nächste. */
  const navMenus = () => [...document.querySelectorAll('.cm-desktop-nav > .cm-nav-menu')];
  let swapTimer = 0;
  let pinnedMenu = null;
  // Capture-Phase: läuft vor cm-motion.js, das beim Öffnen die anderen Menüs schließt. Ist schon eins offen, wird nur
  // der Inhalt gewechselt (keine Zu-und-Auf-Animation, die bei schnellem Überfahren flackern würde).
  document.addEventListener('toggle', (event) => {
    const menu = event.target;
    if (!(menu instanceof HTMLDetailsElement) || !menu.matches('.cm-desktop-nav > .cm-nav-menu') || !menu.open) return;
    if (navMenus().some((other) => other !== menu && other.open)) {
      root.classList.add('cm-nav-swap');
      clearTimeout(swapTimer);
      swapTimer = setTimeout(() => root.classList.remove('cm-nav-swap'), 260);
    }
  }, true);
  const bindMenu = (menu) => {
    if (menu.dataset.higNav) return;
    menu.dataset.higNav = '1';
    const summary = menu.querySelector(':scope > summary');
    let enterTimer = 0;
    let leaveTimer = 0;
    let hoverOpened = false;
    const isMouse = (e) => e.pointerType === 'mouse' && finePointer.matches;
    menu.addEventListener('pointerenter', (e) => {
      if (!isMouse(e)) return;
      clearTimeout(leaveTimer);
      if (menu.open) return;
      if (pinnedMenu && pinnedMenu !== menu && pinnedMenu.open) return;
      // Ist schon ein Menü offen, sofort wechseln; sonst kurz warten, damit Überfahren der Leiste nichts aufklappt.
      const delay = navMenus().some((m) => m.open) ? 0 : 70;
      enterTimer = setTimeout(() => { hoverOpened = true; menu.open = true; }, delay);
    });
    menu.addEventListener('pointerleave', (e) => {
      if (!isMouse(e)) return;
      clearTimeout(enterTimer);
      if (!menu.open || pinnedMenu === menu) return;
      leaveTimer = setTimeout(() => {
        // Tastaturfokus im Menü hält es offen
        if (!menu.matches(':focus-within') || !menu.querySelector(':focus-visible')) menu.open = false;
      }, 220);
    });
    // Mit der Maus geöffnet und darauf geklickt: offen lassen statt zuzuklappen (sonst schließt der Klick, den viele
    // aus Gewohnheit machen, das gerade aufgegangene Menü).
    summary?.addEventListener('click', (e) => {
      clearTimeout(enterTimer);
      clearTimeout(leaveTimer);
      if (hoverOpened && menu.open && menu.matches(':hover')) {
        e.preventDefault();
        pinnedMenu = menu;
        return;
      }
      // Klick öffnet → festhalten; Klick schließt → loslassen (der Browser klappt <details> selbst um).
      pinnedMenu = menu.open ? null : menu;
    });
    menu.addEventListener('toggle', () => {
      if (menu.open) return;
      hoverOpened = false;
      if (pinnedMenu === menu) pinnedMenu = null;
    });
    // Fokus verlässt das Menü per Tab → schließen. Ohne Ziel (Klick auf leere Fläche) nichts tun.
    menu.addEventListener('focusout', (e) => {
      if (e.relatedTarget && !menu.contains(e.relatedTarget) && !menu.matches(':hover')) menu.open = false;
    });
  };

  /* Lichtkante */
  const sheen = (el) => {
    if (el.dataset.higSheen) return;
    el.dataset.higSheen = '1';
    el.classList.add('hig-sheen');
    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      el.style.setProperty('--hig-mx', `${e.clientX - r.left}px`);
      el.style.setProperty('--hig-my', `${e.clientY - r.top}px`);
    }, { passive: true });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('.cm-guide-tabs, .cm-acc-tabs').forEach(segmented);
    scope.querySelectorAll('.cm-desktop-nav > .cm-nav-menu').forEach(bindMenu);
    if (finePointer.matches && !reduced.matches) {
      scope.querySelectorAll('.cm-experience-note, .cm-acc-now-card, .cm-acc-actions-grid a, .cm-guide-panel a, .cm-pause-alt a, .cm-acc-team').forEach(sheen);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  // Reiter, die erst später sichtbar werden (Startseite setzt data-ready), einmal nachziehen.
  addEventListener('load', () => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
